const features = [
  {
    title: "Vernacular Learning",
    desc: "Generates questions in हिन्दी and English with semantic consistency.",
    bg: "bg-cyan-100",
    titlecolor: "text-cyan-800",
    desccolor: "text-cyan-700",
  },
  {
    title: "Auto-Generated, Curriculum-Aligned Questions",
    desc: "From CBSE to State Boards, Kunji generates an endless stream of subject-specific questions, instantly mapped to syllabus objectives.",
    bg: "bg-rose-100",
    titlecolor: "text-rose-800",
    desccolor: "text-rose-700",
  },
  {
    title: "Multiple Formats, One Brain",
    desc: "MCQs, short answers, long-form reasoning, fill-in-the-blanks, and even AI-generated visual prompts—all created by a single intelligent system.",
    bg: "bg-amber-100",
    titlecolor: "text-amber-800",
    desccolor: "text-amber-700",
  },
  {
    title: "Dynamic Difficulty Adjustment",
    desc: "Questions evolve based on student responses using reinforcement learning and adaptive feedback loops.",
    bg: "bg-purple-100",
    titlecolor: "text-purple-800",
    desccolor: "text-purple-700",
  },
  {
    title: "Ask AI",
    desc: "A fully integrated and continuously trained AI chat engine for students to ask any questions/doubts.",
    bg: "bg-pink-100",
    titlecolor: "text-pink-800",
    desccolor: "text-pink-700",
  },
  {
    title: "Bloom's Taxonomy Based Difficulty Tuning",
    desc: "Generate Higher-Order Thinking Skills (HOTS) or basic recall-level quizzes customizable by grade, topic, and learning outcome.",
    bg: "bg-green-100",
    titlecolor: "text-green-800",
    desccolor: "text-green-700",
  },
  {
    title: "Zero Repetition, Maximum Variety",
    desc: "Thanks to stochastic generation and prompt engineering, the question bank never runs dry or stale.",
    bg: "bg-sky-100",
    titlecolor: "text-sky-800",
    desccolor: "text-sky-700",
  },
  {
    title: "Cloud-Hosted Scalability",
    desc: "Seamless integration into any digital classroom ecosystem.",
    bg: "bg-yellow-100",
    titlecolor: "text-yellow-800",
    desccolor: "text-yellow-700",
  },
];

export { features };
